// extracted by mini-css-extract-plugin
export var actionText = "_ku-4";
export var container = "_ku-0";
export var leftSection = "_ku-1";
export var rightSection = "_ku-2";
export var settingsButton = "_ku-6";
export var settingsIcon = "_ku-7";
export var shortcut = "_ku-5";
export var shortcutGroup = "_ku-3";